<emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
@if (item$ | async; as item) {
  <emm-attributes-header
    [countryCode]="countryCode"
    [disabledCode]="item['disabledCode']"
    [disabledSystem]="item['disabledSystem']"
    [disabledSource]="item['disabledSource']"
    [disabledReasons]="item['disabledReasons']"
    [name]="item.name"
    [tag]="item.tag"
    [type]="item['typeName']"
    [subType]="item['itemSubType']"
    [featureScope]="scope"
  ></emm-attributes-header>
}
@if (renderForm | async) {
  <div class="form-content">
    @if (item$ | async; as item) {
      <main [style.width]="rightPaneWidth">
        <emm-attributes-form
          [rightPaneWidth]="rightPaneWidth"
          [attributeGroups]="attributeGroups"
          [attributesByGroup]= "attributesByGroup"
          [form]="form | async"
          [item]="item"
          [selectedSubmenu]="selectedSubmenu$ | async"
          [isReadOnly$]="isReadOnly$"
          [model]="valuesObservable | async"
          [options]="options"
          [featureScope]="scope"
          [menuParams]="menuParamsContext$ | async"
          [effectiveDate]="effectiveDate | async"
          [nodeId]="item.id"
          [selectedFeatureScope$]="selectedFeatureScope$"
          [dialogService]="dialogService"
          [locationSet]="locationSet"
          [itemNode]="itemNode"
          [isSubMenu]="isSubMenu"
          [language]="language$ | async"
          [previousAttributeGroups]="previousAttributeGroups$ | async"
          (attributeGroupSelected)="onAttributeGroupSelected($event)"
          (submenuRenamed)="onSubmenuRenamed($event)"
        ></emm-attributes-form>
        <div></div>
        <div></div>
      </main>
    }
  </div>
}
